import { render, staticRenderFns } from "./RecoveryCodes.vue?vue&type=template&id=364af68c&scoped=true&"
import script from "./RecoveryCodes.vue?vue&type=script&lang=js&"
export * from "./RecoveryCodes.vue?vue&type=script&lang=js&"
import style0 from "./RecoveryCodes.vue?vue&type=style&index=0&id=364af68c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364af68c",
  null
  
)

export default component.exports